<template>
  <div class="mx-0">
    <Header title="E-Wallet & Pulsa" />
    <CategoriesEwallet />
    <dataEwallet
      :status="OutletData.status_registrasi"
      :phones="availablePhoneNumbers"
      :restricted="restrictPhoneNumber"
    />
  </div>
</template>

<script>
import axios from "axios";
import Header from "../components/Catalog/Header";
import CategoriesEwallet from "../components/Catalog/CategoriesEwallet";
import dataEwallet from "../components/Catalog/dataEwallet";

export default {
  components: {
    Header,
    CategoriesEwallet,
    dataEwallet
  },
  data() {
    return {
      OutletData: {
        data: []
      },
      restrictPhoneNumber: true
    };
  },

  computed: {
    availablePhoneNumbers() {
      const phones = [this.OutletData.no_hp, this.OutletData.whatapps];

      return phones.filter((item, pos) => phones.indexOf(item) === pos);
    }
  },

  methods: {
    getOutlet() {
      axios
        .get(`${process.env.VUE_APP_URL}status-poin-rebate`, {
          params: {
            outlet_id: this.$route.params.outlet_id,
            token: localStorage.token
          }
        })
        .then(res => (this.OutletData = res.data.data))
        .catch(err => console.log(err));
    },
    resetEwallet() {
      this.$store.state.cartEwallet = [];
    }
  },
  mounted() {
    this.getOutlet();
    this.resetEwallet();
  }
};
</script>

<style scoped></style>
